<template>
    <ConfirmComponent />
    <AlarmComponent />
    <div class="app-content">
        <u-header v-if="user" />
        <main>
            <div class="main__content">
                <u-sidebar v-if="user" />
                <div
                    :class="{
                        view__content: user?.id,
                        'view__content-auth': !user?.id,
                    }"
                >
                    <div class="breadcrumb-wrapper" v-if="breadCrumbs.length">
                        <BreadcrumbItem :model="breadCrumbs" />
                    </div>
                    <router-view />
                </div>
            </div>
        </main>
        <FooterComponent />
    </div>
    <div id="modalReAuth"></div>
</template>

<script>
import UHeader from "@/components/Header";
import USidebar from "@/components/Sidebar";
import { mapGetters } from "vuex";
import AlarmComponent from "@/components/Alarm";
import FooterComponent from "@/components/Footer";
import ConfirmComponent from "@/components/Confirm";

export default {
    components: {
        FooterComponent,
        AlarmComponent,
        USidebar,
        UHeader,
        ConfirmComponent,
    },
    data() {
        return {
            isOpen: true,
        };
    },
    computed: {
        ...mapGetters({
            // isAuth: "user/isAuthenticated",
            user: "user/stateUser",
        }),
        breadCrumbs() {
            if (this.$route.meta?.breadCrumb) {
                if (typeof this.$route.meta.breadCrumb === "function") {
                    return this.$route.meta.breadCrumb.call(this, this.$route);
                }
                return this.$route.meta.breadCrumb;
            } else {
                return [];
            }
        },
    },
};
</script>

<style lang="scss">
.app-content {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    main {
        flex: 1 0 auto;
    }
    .view__content {
        margin: 70px 0 0 200px;
        width: calc(100% - 200px);
        min-height: calc(100vh - 70px);
        transition: 0.2s;
    }
    .view__content-full {
        margin: 70px 0 0 60px;
        width: calc(100% - 60px);
        transition: 0.2s;
    }
    .view__content-auth {
        width: 100%;
        margin: 0;
        height: 100%;
        min-height: auto;
        padding: 0 100px;
    }
}
</style>
